// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectPayment_root__1qba8","text":"SelectPayment_text__2hAfs","title":"SelectPayment_title__1Nn3l","btn":"SelectPayment_btn__DN4_A"};